import React from 'react';
import { Row, Col } from 'reactstrap';
import { renderHTMLContent } from '../../../../common/function';

function ViewAnswer(props) {
  const {
    multiple_answer,
    grading_details,
    is_multiple,
    development_justification,
    handleChange,
    userGrading,
    max_grading,
    selectedChoice,
    disabled,
  } = props;
  let choices = [];
  let justification = [];
  for (const objKey in props) {
    if (objKey.includes('choice'))
      if (props[objKey]) choices.push(props[objKey]);
    if (objKey.includes('development_justification'))
      if (props[objKey]) justification.push(props[objKey]);
  }
  return (
    <div className='note-section note-section-new view_questionhtml'>
      <div className='card'>
        <div className='font-lusitana'>
          <div className='card-header'>
            {is_multiple ? (
              selectedChoice === multiple_answer ? (
                <div className='text_success'>Correct</div>
              ) : selectedChoice ? (
                <div className='text_failure'>Incorrect</div>
              ) : (
                <div className='text_unAttempted'>Not Attempted</div>
              )
            ) : null}
          </div>
          <div className='card-block'>
            <Row>
              {development_justification.includes('&;') ? (
                <Col>
                  <div className={`col-12 border-gray rounded p-1`}>
                    <b>
                      {development_justification.split('&;')[0].split(':')[0]} :
                    </b>
                    <span>
                      {development_justification.split('&;')[0].split(':')[1]}{' '}
                    </span>
                  </div>
                </Col>
              ) : null}
              {is_multiple ? (
                <Col
                  className='mb-md-0 mb-sm-1'
                  sm='12'
                  md={development_justification.includes('&;') ? '12' : '4'}
                >
                  <div
                    className={`${development_justification.includes('&;') ? 'p-2' : ''
                      } border-gray rounded d-flex justify-content-center align-items-center h-100 p-2`}
                  >
                    <span className='border-solid-1 p-2 rounded-circle text-center'>
                      {multiple_answer}
                    </span>
                  </div>
                </Col>
              ) : null}
              {!is_multiple && choices.length
                ? choices.map((element, index) => (
                  <Row>
                    <Col sm='12' md='6'>
                      <div
                        className={`p-2
                    border-gray rounded d-flex justify-content-center align-items-center`}
                      >
                        <span className='p-2'>{element}</span>
                      </div>
                    </Col>
                    <Col sm='12' md='6'>
                      <div
                        className={`p-2
                    border-gray rounded d-flex justify-content-center align-items-center`}
                      >
                        <span className='p-2'>{justification[index]}</span>
                      </div>
                    </Col>
                  </Row>
                ))
                : null}
              {!(!is_multiple && choices.length) &&
                development_justification ? (
                <Col
                  className='col-12'
                  sm='12'
                  md={
                    development_justification.includes('&;') || !is_multiple
                      ? '12'
                      : '8'
                  }
                >
                  <div className=''>
                    <div
                      className={`${development_justification.includes('&;') || !is_multiple
                        ? 'p-2'
                        : ''
                        } border-gray rounded p-2`}
                    >
                      {development_justification.includes('&;') ? (
                        <b>Justification:</b>
                      ) : is_multiple ? (
                        selectedChoice === multiple_answer ? (
                          <p className='text-success  d-block font-weight-bold'>
                            You Selected the Correct Answer: {multiple_answer}
                          </p>
                        ) : selectedChoice ? (
                          <p className='text-danger d-block font-weight-bold'>
                            You Selected the Incorrect Answer. The Correct
                            Answer is: {multiple_answer}
                          </p>
                        ) : (
                          <p className='d-block font-weight-bold'>
                            The Correct Answer is: {multiple_answer}
                          </p>
                        )
                      ) : null}
                        {renderHTMLContent(
                          development_justification.includes('&;')
                            ? development_justification.split('&;')[1]
                            : development_justification,
                          "span"
                        )}
                    </div>
                  </div>
                </Col>
              ) : null}
              <Col className='col-12'>
                <div className='mt-2'>
                  {grading_details ? (
                    <div className='bg-secondary w-100 rounded p-1'>
                      <Row>
                        <Col className='col-12' sm='12' md='9'>
                          <b>Candidate grading:</b>{' '}
                          {renderHTMLContent(grading_details, "span")}
                        </Col>
                        <Col className='col-12 mt-1 mt-md-0' sm='12' md='3'>
                          {/* <div>Select Grading : </div> */}
                          <select
                            id='select'
                            name='userGrading'
                            className='form-control input-sm'
                            onChange={(e) => handleChange(e)}
                            disabled={disabled}
                            value={userGrading}
                            size='1'
                          >
                            <option value='Select grading'>
                              Select Grading{' '}
                            </option>
                            {Array(max_grading + 1)
                              .fill(0)
                              .map((element, index) => {
                                return (
                                  <option value={`${index}`} key={index}>
                                    {index}
                                  </option>
                                );
                              })}
                          </select>
                        </Col>
                      </Row>
                    </div>
                  ) : null}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewAnswer;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Layout/ViewAnswer.jsx